var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5315 5.05395C20.5315 2.80362 18.7072 0.97937 16.4569 0.97937C14.2066 0.97937 12.3823 2.80363 12.3823 5.05395V7.17498C12.3823 10.5943 9.61044 13.3661 6.19116 13.3661L4.07458 13.3661C1.82425 13.3661 0 15.1904 0 17.4407C0 19.691 1.82425 21.5153 4.07457 21.5153H6.19116C9.61044 21.5153 12.3823 24.2872 12.3823 27.7064V29.8276C12.3823 32.078 14.2066 33.9022 16.4569 33.9022C18.7072 33.9022 20.5315 32.078 20.5315 29.8276V27.7088C20.5315 24.2882 23.3044 21.5153 26.7249 21.5153H28.8483C31.0986 21.5153 32.9229 19.691 32.9229 17.4407C32.9229 15.1904 31.0986 13.3661 28.8483 13.3661L26.7248 13.3661C23.3043 13.3661 20.5315 10.5933 20.5315 7.17275V5.05395Z",
    fill: "#198CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBlue);
export default __webpack_public_path__ + "static/media/plus-icon-blue.f8282cdb6eb3027b9433cb5f8751e263.svg";
export { ForwardRef as ReactComponent };